'use client';
import { FullListing } from '@th/shared/src/types/FullListing';
import ListingHeaderEstimate from './ListingHeaderEstimate';
import { clsx } from 'clsx';
import blurText from '../../helpers/blurText';

type Props = {
  listing: FullListing;
  isBlurred: boolean;
};
export function ListingPriceHeader({ listing, isBlurred }: Props) {
  const listingEstimate =
    listing.isActive() && listing.isSale() ? (
      <ListingHeaderEstimate listingId={listing.id} />
    ) : null;

  const additionalHeaderText = listing.isSoldOrLeased() ? (
    <p className="text-secondaryText ml-4">
      Listed for {listing.listPrice.formatAsPrice()}
    </p>
  ) : (
    listingEstimate
  );

  return (
    <div className="flex items-baseline">
      <h3 className={clsx(isBlurred && 'blur-md')}>
        {blurText(listing.displayPrice(), isBlurred)}
      </h3>
      {additionalHeaderText}
    </div>
  );
}
